<template>
    <div>
        <div ref="consumerInsightBarChart" style="min-height: 400px;"></div>
    </div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
                dummyData : [
                    {age:'<17', scan:this.randomInt(1, 4)},
                    {age:'17-20', scan:this.randomInt(1, 4)},
                    {age:'21-24', scan:this.randomInt(1, 4)},
                    {age:'25-29', scan:this.randomInt(1, 4)},
                    {age:'30-34', scan:this.randomInt(1, 4)},
                    {age:'35-39', scan:this.randomInt(1, 4)},
                    {age:'40-44', scan:this.randomInt(1, 4)},
                    {age:'45-49', scan:this.randomInt(1, 4)},
                    {age:'50-54', scan:this.randomInt(1, 4)},
                    {age:'>54', scan:this.randomInt(1, 4)}
                ],
            }
        },
        mounted () {
            this.createChart();
            this.getData();
        },
        methods : {
            getData () {
                let length = this.chart.data.length;

                this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{age:'No Data', scan:0}],length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end



                this.chart = am4core.create(this.$refs.consumerInsightBarChart, am4charts.XYChart)

                this.chart.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1")
                ]

                this.chart.legend = new am4charts.Legend()
                this.chart.legend.position = 'top'
                this.chart.legend.align = 'end'
                this.chart.legend.paddingBottom = 20
                this.chart.legend.labels.template.maxWidth = 95

                let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                xAxis.dataFields.category = 'age'
                xAxis.renderer.cellStartLocation = 0.1
                xAxis.renderer.cellEndLocation = 0.9
                xAxis.renderer.grid.template.location = 0;

                let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                yAxis.min = 0;

                this.chart.cursor = new am4charts.XYCursor();

                this.createSeries('scan', 'Scan');
                // this.createSeries('suspicious', 'Suspicious');

            },
            createSeries(value, name) {
                let series = this.chart.series.push(new am4charts.ColumnSeries())
                series.dataFields.valueY = value
                series.dataFields.categoryX = 'age'
                series.name = name
                series.columns.template.tooltipText = "[#fff font-size: 15px]{name} activity in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]"
                series.columns.template.column.cornerRadiusTopLeft = 10;
                series.columns.template.column.cornerRadiusTopRight = 10;

                // series.events.on("hidden", arrangeColumns);
                // series.events.on("shown", arrangeColumns);

                let bullet = series.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.dy = 15;
                bullet.label.text = '{valueY}'
                bullet.label.fill = am4core.color('#ffffff')

                return series;
            }
        }
    }
</script>

<style scoped>

</style>